export const app_name = process.env.VUE_APP_NAME;
export const api_base_url = process.env.VUE_APP_API_BASE_URL;
